import { useQuery } from '@apollo/client';
import mindfulnessGraph from '../../graphql-queries/mindfulness';

export function useMindfulness() {
  return useQuery(mindfulnessGraph.GET_MINDFULNESSES, {
    fetchPolicy: 'cache-and-network'
  });
}
